import { render } from "./CareHomePage.vue?vue&type=template&id=561b890a&scoped=true"
import script from "./CareHomePage.vue?vue&type=script&lang=js"
export * from "./CareHomePage.vue?vue&type=script&lang=js"

import "./CareHomePage.vue?vue&type=style&index=0&id=561b890a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561b890a"]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading});
